import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

const AllResearchPapers = () => {
  const [papers, setPapers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPapers();
  }, []);

  const fetchPapers = async () => {
    try {
      const res = await api.get("/api/research-papers/admins/all");

      // ✅ show ONLY approved articles
      const approvedOnly = (res.data || []).filter(
        (paper) => paper.status === "APPROVED"
      );

      setPapers(approvedOnly);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Approved Research Papers</h2>

      <ul className="list-group">
        {papers.map((p) => (
          <li key={p.id} className="list-group-item mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">{p.title}</h5>

              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => navigate(`/admin/research/${p.id}`)}
              >
                View Full Research
              </button>
            </div>

            <p className="mt-2 mb-0">
              <b>Status:</b>{" "}
              <span style={{ color: "green" }}>APPROVED</span>
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AllResearchPapers;
